export const genderOptions = [
  {
    genderId: '1',
    gender: 'Male',
    genderTitle: 'Male',
  },
  {
    genderId: '2',
    gender: 'Female',
    genderTitle: 'Female',
  },
  {
    genderId: '3',
    gender: 'Unknown',
    genderTitle: 'Unknown',
  },
];
